import $ from 'jquery';
import {h, Component} from 'preact';
import { H } from 'highlight.run';
import AppHeader from './AppHeader';
import AppSubheader from './AppSubheader';
import AppAside from './AppAside';
import AppAsideRight from './AppAsideRight';
import AppCanvas from './AppCanvas';
import RightMenu from './RightMenu';
import Promos from './Promos';
import NewTemplateModal from './NewTemplateModal';
import OfflineBanner from './OfflineBanner';
import AppAdmin from './AppAdmin';
import PrintAdvisor from './PrintAdvisor';
import store from '../store';
import * as actions from '../actions';
import reduce from '../reducers';
import util, {detectDotLeaderLayout, forceHttps, initUrl, showDotLeaderWarningModal, toLogIn, showInUseOnOpenModal, showNoLocationPermissionModal, syncUploadedImagesAltTextOnCanvas, syncUploadedIconsAltTextOnCanvas } from '../util';
import Canvas from '../canvas';
import {renderDesign} from '../canvas/renderer';
import designDomain from '../domain/designDomain';
import designService from '../service/designService';
import imageService from '../service/imageService';
import ImportFromWebsite from './ImportFromWebsite';
import MenuContentModal from './MenuContentModal';
import CollectionModal from "./CollectionModal";
import {connect} from "react-redux";
import MobileAppHeader from "./mobile/MobileAppHeader";
import MobileAppSubheader from "./mobile/MobileAppSubheader";
import MobileAppMenu from "./mobile/MobileAppMenu";
import MobileAppAside from "./mobile/MobileAppAside";
import qrCodeService from '../service/qrCodeService';
import {disableNewPages, refreshPageIds, initPageBars} from '../canvas/page';
import configService from "../service/configService";
import {AppLoading} from "./AppLoading";
import brandService from '../service/brandService';
import AppAsideNav from "./AppAsideNav";
import {BUILD} from "../env";
import {initDesignInStore} from "../service/storeService";
//import { InUseModal } from './InUseModal';
//import { NoLocationPermissionModal } from './NoLocationPermissionModal';
import { deleteFramePreview, adjustAfterPageResize } from '../canvas/reposition-frame';
import frontendLogService from '../service/frontendLogService';
import MatchingDesignModal from "./MatchingDesignModal";
import DataLibrary from "./DataLibrary";
import { getMenuGroup } from '../service/menuGroupService';
import PosConnectModal from './PosConnectModal';
import PosVerifiedPage from './PosVerifiedPage';
import { getMenuGroupsFromDesign } from '../canvas/menu-group';
import MMGTourModal from './MMGTourModal';
import VideoPlaybackControls from './VideoPlaybackControls';
import constants from "../constants";
import { datadogRum } from '@datadog/browser-rum';
import menuObject from '../canvas/menu-object';
import POSTourModal from './POSTourModal';
import AiMenuBuilder from './AiMenuBuilder';
import {setIsDSADesign, setIsLeftMenuVisible} from "../actions";
import AltTextModal from "./AltTextModal";
import favoriteAssetService from '../service/favoriteAssetService';
import PublishWarningBanner from "./PublishWarningBanner";

const RENEW_PATH = '/menu/renewBill.do?tb=CANCELLED_MEMBER';

export default @connect(reduce, actions)
class App extends Component {
  constructor() {
    super();

    this.state = {
      isAiBuilder: data.props.ai,
      isInUse: false,
      noLocationPermission: false,
      isTemplateModal: false,
      appEnvironment: window.data.props.appEnvironment,
      appServer: window.data.props.appServer,
      isMobileMenu: false,
      matchingDesignModalOpen: false,
      toastActive: true, //!!window.localStorage.getItem('toast')
      isPosVerifyMode: false,
      uploadedImages: [],
      uploadedIcons: [],
      hasViewOnlyPermission: false,
      isPublishWarningBanner: false,
    };

    this.onTemplateModalClose = () => this.setState({isTemplateModal: false});
    this.onMenuContentModalClose = () => this.props.hideMenuContentModal();
    this.onMatchingDesignModalClose = () => {
      this.setState({matchingDesignModalOpen: false});
      this.closeAppAsideRight();
    }

    this.toggleMobileMenu = this.toggleMobileMenu.bind(this);
    this.closeAppAsideRight = this.closeAppAsideRight.bind(this);
    this.showMatchingDesignsModal = this.showMatchingDesignsModal.bind(this);
    this.setUploadedImages = this.setUploadedImages.bind(this);
    this.setUploadedIcons = this.setUploadedIcons.bind(this);
  }

  componentDidMount() {
    this.init();
  }

  componentDidCatch(error) {
    const {memberId, designId} = store.getState();
    frontendLogService.log(memberId, designId, `${error.name}\n${error.message}\n${error.stack}`);
  }

  checkMobileVersion() {
    if ($('#mob-detect').is(':visible')) {
      this.props.setMobileVersion(true);
      document.body.classList.add('b-mob');
    }

    if(('ontouchstart' in window) || ( navigator.maxTouchPoints > 0 ) || ( navigator.msMaxTouchPoints > 0)) {
      window.data.props.isTouchScreen = true;
    }

    //UNCOMMENT BELOW TO BLOCK ANDROID ON MOBILE
    /*const userAgent = (navigator.userAgent || navigator.vendor || window.opera).toLowerCase();
    const isAndroid = userAgent.indexOf('android') !== -1;
    if (isAndroid && !this.props.isAdmin) {
      document.body.classList.add('blocked-for-mobile');
    }*/
  }

  checkEmbedded() {
    this.props.setIniFrame(util.iniFrame());
  }

  init() {
    const urlParams = new URLSearchParams(window.location.search);
    if (!window.localStorage.getItem('tkn')) {
      if (urlParams.get('pos-verification')) {
        window.location.href = '/account/login?next=' + window.location.href;
      } else {
        window.location.href = '/account/login';
      }
      return;
    }

    forceHttps();
    window.$ = $;

    if (urlParams.get('pos-verification')) {
      this.setState({isPosVerifyMode: true});
      store.dispatch(actions.setIsAppLoading(false));
      return;
    }

    store.dispatch(actions.setIsDesignLoading(true));

    this.initApp(() => {
      const state = store.getState();
      if (state.classicId && state.parentId) {
        this.initDesignFromClassic();
      } else if (state.parentId) {
        this.initDesignFromParent();
      } else {
        this.initDesign();
      }

      util.initIdleCheck();
      util.initSessionIdleCheck();
      util.initDropdown();

      if (!state.isLogged) {
        toLogIn();
      }

      this.edgeFix();

      window.data.design.autoClickedPublish = false;

      store.dispatch(actions.setIsAppLoading(false));

      util.nextTick(() => {
        this.checkMobileVersion();
        this.checkEmbedded();
      });
    });

    this.showPublishWarningBanner = () => {
      this.setState({isPublishWarningBanner: true});
    }

    this.closePublishWarningBanner = () => {
      this.setState({isPublishWarningBanner: false});
    }
  }


  initApp(callback) {
    let {id, parentId, locationId, initialSize} = window.data.design;

    if (!locationId) {
      locationId = util.getLocationIdFromStorage();
    }

    configService.initApp(id, parentId, locationId, initialSize).then(resp => {
      const dto = resp.data;

      if (!dto.isLogged) {
        toLogIn();
      }

      if (!dto.hasDesignPermission) {
        toLogIn();
        return;
      }
      if (!dto.hasAccountPermission) {
        window.location.href = RENEW_PATH;
        return;
      }

      window.data.showErrorOverlay = dto.showErrorOverlay;

      window.data.member.id = dto.memberId;
      window.data.member.userId = dto.userId ? dto.userId : dto.memberId;
      window.data.member.email = dto.memberEmail;
      window.data.member.statusDescription = dto.memberStatusDescription;
      window.data.member.memberNameAbbreviation = dto.memberNameAbbreviation;
      window.data.member.ownerName = (dto.ownerName || "").trim();
      window.data.member.hasViewOnlyPermission = dto.hasViewOnlyPermission;

      window.data.member.aiCountLimit = dto.aiCountLimit;
      window.data.member.aiCurrentCount = dto.aiCurrentCount;

      this.setState({hasViewOnlyPermission: dto.hasViewOnlyPermission});
      if (dto.hasViewOnlyPermission) {
        store.dispatch(setIsLeftMenuVisible(false));
      }

      window.data.design.isNewDesign = dto.isNewDesign;
      window.data.design.id = dto.designId;
      window.data.design.locationId = dto.locationId;
      window.data.design.locationName = dto.locationName;
      window.data.locations = dto.locations;
      window.data.squareRestaurants = dto.squareRestaurants;
      window.data.squareLocations = dto.squareLocations;

      window.data.downloads = dto.downloads;
      window.data.templates = dto.templates;
      window.data.printing = dto.printing;

      store.dispatch(actions.setDesignId(dto.designId));
      store.dispatch(actions.setLocationId(dto.locationId));
      store.dispatch(actions.setIsTemplateLink(dto.isTemplateLink));
      store.dispatch(actions.setPosData(dto.posBeta, dto.toastEmail, dto.isClover, dto.isSquare, dto.isTreez, dto.isPopmenu));

      if (dto.locationId) {
        brandService.getBrandPerLocation(dto.locationId).then((resp) => {
          if (resp.data) {
            const brand = resp.data;
            store.dispatch(actions.setBrand(brand));
            util.initFavoriteFontsLoad(brand);
            util.initCustomFontsLoad(brand);
            syncUploadedImagesAltTextOnCanvas(brand.logos);
            window.data.member.uploadedLogos = brand.logos;
            window.data.member.brandColors = brand.colors;
          }
        });
      }

      if (dto.isLogged) {
        store.dispatch(actions.login({
          ...dto,
          id: dto.memberId,
          locationId: dto.locationId,
          country: dto.memberCountry,
          status: dto.memberStatus,
          printing: dto.printing,
          templates: dto.templates,
          downloads: dto.downloads
        }));

        store.dispatch(actions.setIsNewDesign(dto.isNewDesign));
      }

      if (dto.memberEmail) {
        window.pagesense = window.pagesense || [];
        window.pagesense.push(['identifyUser', `${dto.memberEmail}`]);
      }

      if (dto.memberId && dto.locationId) {
        imageService.getLocationImages(dto.memberId, dto.locationId).then(response => {
          const uploadedImages = response.data;
          this.setState({ uploadedImages: uploadedImages });
          syncUploadedImagesAltTextOnCanvas(uploadedImages);
          window.data.member.uploadedImages = uploadedImages;
        });
      }

      if (dto.memberId && dto.locationId) {
        imageService.getLocationIcons(dto.memberId, dto.locationId).then(response => {
          const uploadedIcons = response.data;
          this.setState({ uploadedIcons: uploadedIcons });
          syncUploadedIconsAltTextOnCanvas(uploadedIcons);
          window.data.member.uploadedIcons = uploadedIcons;
        })
      }

      if (dto.memberId) {
        favoriteAssetService.getFavoriteAssets(dto.memberId).then(response => {
          console.log("favorite assets", response.data);
          store.dispatch(actions.setFavoriteAssets(response.data));
        })
      }

      this.initDataDog(dto);

      util.nextTick(() => {
        callback();
      })
    });
  }

  initHighlight(dto) {
    H.init('6gl1kzd9', {
      tracingOrigins: true,
      networkRecording: {
        enabled: true,
        recordHeadersAndBody: true,
        urlBlocklist: [],
      },
    });

    H.identify(dto.memberId.toString(), {
      email: dto.memberEmail,
    });
  }

  initDataDog(dto) {
    datadogRum.init({
      applicationId: 'a9eb41c0-1c23-4de5-9302-c8a981bc5821',
      clientToken: 'pub8a2bc7e7c1fe41c60ada75d06bd3871d',
      site: 'datadoghq.com',
      service:'musthavemenus',
      env: constants.isTestEnv ? 'test' : constants.isStageEnv ? 'stage' : 'prod',
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
      silentMultipleInit: true,
    });
    datadogRum.setUser({
      id: dto.memberId,
      email: dto.memberEmail
    });
  }

  edgeFix() {
    if (!HTMLCanvasElement.prototype.toBlob) {
      Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
        value: function (callback, type, quality) {
          let dataURL = this.toDataURL(type, quality).split(',')[1];
          setTimeout(function () {
            let binStr = atob(dataURL);
            let len = binStr.length;
            let arr = new Uint8Array(len);
            for (let i = 0; i < len; i++) {
              arr[i] = binStr.charCodeAt(i);
            }
            callback(new Blob([arr], {type: type || 'image/png'}));
          });
        }
      });
    }
  }

  initDesign() {
    const designId = window.data.design.id;

    designService.getDesign(designId, false, false).then((response) => {
      const designData = response.data;

      if (designData.removed) {
        const urlPieces = window.location.href.split("id=");
        const newUrl = `${urlPieces[0]}id=removed`;
        window.location.replace(newUrl);
        return;
      }


      if (designData.inUseLastPingAt && window.data.member.userId !== designData.inUseMemberId &&  (new Date().getTime() - designData.inUseLastPingAt) < constants.DESIGN_IN_USE_SECONDS * 1000) {
        showInUseOnOpenModal();
        return;
      }

      if (designData.type !== "template" && !window.data.locations.map(loc => loc.internalId).includes(designData.locationId) && window.location.host.indexOf("localhost:") === -1) {
        showNoLocationPermissionModal();
        return;
      }

      this.loadDesign(designData);

      getMenuGroup(designId).then(resp => {
        const groups = JSON.parse(!!resp.data ? (resp.data.data ?? "[]") : "[]");

        store.dispatch(actions.setMenuGroups(groups));
        store.dispatch(actions.setMenuGroupsSource(resp.data?.source ?? ""));

        if (groups.length === 0 && response.data.hasChanges) {
          setTimeout(getMenuGroupsFromDesign, 1000);
        } else if (groups.filter(it => it.name.includes('Untitled (')).length > 0) {
          setTimeout(getMenuGroupsFromDesign, 1000);
        }
      });

      if ($('[data-component="page"]').length >= constants.maxDesignPages) {
        disableNewPages();
      }

      util.nextTick(() => {
        if ($('#design-cfg').attr('just-combined') === 'true') {
          refreshPageIds();
          util.resassignMenuObjectIds();
          $('#design-cfg').attr('just-combined', 'false');
        }

        deleteFramePreview();

        const dims = util.getActiveDimensions();
        let size = util.getSize(dims.key);
        store.dispatch(actions.setDesignSize(size));

        initPageBars();

        $('.pages .page .content div[data-component="frame"]').each(function() {
          adjustAfterPageResize($(this));
        })

        menuObject.findMenuActiveIcons();

        // this.showMatchingDesignsModal(); // temp
      }, 500);

      qrCodeService.designHasQRCode(designId).then(resp => {
        if (resp) {
          window.data.design.qrCodeId = resp.data;
        }
      });

      qrCodeService.designIsOnLP(this.props.designId).then((resp) => {
        if (resp) {
          window.data.design.landingPageId = resp.data;
        }
      });

      $('video').each(function() {
          this.muted = true;
          this.play();
      });
    })
  }

  initDesignFromParent() {
    const state = store.getState();
    designService.createDesignFromParent({
      parentId: state.parentId,
      locationId: state.locationId,
      memberId: state.memberId,
      visitorId: state.visitorId
    }).then((response) => {
      this.loadDesign(response.data, {isFromTemplate: true});
    })
  }

  initDesignFromClassic() {
    const state = store.getState();

    designService.createDesignFromClassic({
      parentId: state.parentId,
      classicId: state.classicId,
      importStyles: state.importStyles,
      importSize: state.importSize,
      importName: this.props.importName,
      importAccount: this.props.importAccount,
      locationId: state.locationId,
      memberId: state.memberId,
      visitorId: state.visitorId
    }).then((response) => {
      this.loadDesign(response.data, {isFromTemplate: true});
    })
  }

  loadDesign(data, config) {
    config = config || {};
    const design = new designDomain.Design(data);

    if (config.isFromTemplate) {
      design.hasChanges = true;
    }

    if (window.data.showErrorOverlay) {
      $('#error-overlay').show();
    }

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('folderId') && !data.folders) {
      window.data.design.addToFolderId = urlParams.get('folderId');
      design.folders = urlParams.get('folderId');
    }

    let asideSet = false;
    if ((!window.location.href.includes('size=') && !config.isFromTemplate) || window.location.href.indexOf("open=integration") > -1) {
      this.props.goToView('text-mo');
      this.props.goToSubview('add-new');
      asideSet = true;

      if (window.location.href.indexOf("open=integration") > -1) {
        store.dispatch(actions.setIsPosConnectModal(true));
      }
    }

    initUrl(design.id);

    initDesignInStore(design);
    renderDesign(design, {...config, isMobile: store.getState().isMobileVersion});
    if (!window.data.member.hasViewOnlyPermission) {
      Canvas.init();
    }

    this.showTemplateModal();

    this.getPromoTemplates(design.size);

    if (window.location.href.indexOf("open=print") > -1) {
      this.props.goToView('print');
    } else if (!asideSet) {
      this.props.goToView('templates');
    }

    if (window.data.design.qrCodeToAdd) {
      if (store.getState().isMobileVersion) {
        store.dispatch(actions.setIsMobileAside(true));
      }
      this.props.goToView('qr-codes');
    }

    if (detectDotLeaderLayout() && util.isSafari()) {
      showDotLeaderWarningModal();
    }

    menuObject.markConfigsUntranslatable();
    menuObject.checkPosDataUsage();

    const dataLayer = window.dataLayer || [];
    if (dataLayer.push) {
      dataLayer.push({
        event: 'timberData',
        memberId: window.data.member.id,
        locationId: window.data.member.locationId,
        designId: window.data.design.id,
        parentId: window.data.design.parentId,
      });
    }

    qrCodeService.getShareLink(design.id, constants.SL_TYPE_DSA).then((resp) => {
      if (resp.data) {
        store.dispatch(setIsDSADesign(true));
      }
    });

    if (config.isFromTemplate) {
      util.nextTick(() => {
        menuObject.fixDefaultIconColor();
      })
    }
  }

  showTemplateModal() {
    const props = this.props;
    if (props.isNewDesign && (props.isDesigner || props.isAdmin) && !props.iniFrame) {
      this.setState({isTemplateModal: true});
    }
  }

  getPromoTemplates(size) {
    // store.dispatch(setTemplateView('group'));
    store.dispatch(actions.setTemplateGroups([], true));

    const sizeLabel = util.getSizeLabel(size);
    store.dispatch(actions.setSelectedFamily(sizeLabel));

    designService.getTemplatesByStatusAndSizeGrouped(sizeLabel).then((response) => {
      store.dispatch(actions.setTemplateGroups(response.data));
    }).catch(() => {
      store.dispatch(actions.setTemplateGroups([], false));
    })
  }

  exitPreview() {
    util.disableFullScreenPreview();
  }

  toggleMobileMenu() {
    this.setState(old => ({isMobileMenu: !old.isMobileMenu}));
  }

  closeAppAsideRight() {
    this.props.goToView('text-mo');
    this.props.goToSubview('add-new');
  }

  onDataLibraryClose() {
    store.dispatch(actions.setIsDataLibraryModal(false));
    store.dispatch(actions.setIsMobileAside(false));
  }

  showMatchingDesignsModal() {
    if (store.getState().isMobileVersion) this.closeAppAsideRight();
    this.setState({matchingDesignModalOpen: true});
  }

  setUploadedImages(uploadedImages) {
    this.setState({uploadedImages: uploadedImages});
  }

  setUploadedIcons(uploadedIcons) {
    this.setState({uploadedIcons: uploadedIcons});
  }

  render(props, state) {
    const environment = state.appEnvironment === 'prod' ? `-${state.appServer}` : `-${state.appEnvironment}`;

    const dimensions = util.getActiveDimensions();
    const width = dimensions ? dimensions.size.widthNoBleed : '';
    const height = dimensions ? dimensions.size.heightNoBleed : '';
    const showPublishChanges = (props.websiteToken || window.data.design.qrCodeId || window.data.design.landingPageId ||
      window.data.design.justAddedToLP || window.data.props.raydiantWindowOpened || window.data.props.optiSignWindowOpened ||
      window.data.props.telemetryWindowOpened) && !store.getState().isDSADesign && !window.data.member.hasViewOnlyPermission;
    const showPublishChangesDSA = store.getState().isDSADesign && !window.data.member.hasViewOnlyPermission;

    if (props.isAppLoading && !state.isAiBuilder) {
      return <AppLoading message={props.appLoadingInfo}/>;
    }
    if (state.isPosVerifyMode) {
      return <PosVerifiedPage/>
    }
    if (state.isAiBuilder) {
      return <AiMenuBuilder />
    }
    return <div
      className={`app ${(props.isAdmin || props.isDesigner || props.isWriter) && !props.iniFrame ? 'admin-mode' : ''} ${props.isMobileVersion ? 'mob' : ''} ${store.getState().isLeftMenuVisible ? 'left-menu-opened' : 'left-menu-closed'}`}>
      <div id={'mob-detect'}/>
      <OfflineBanner/>
      {!props.isMobileVersion && !props.iniFrame && <AppAdmin/>}

      {!props.isMobileVersion &&
        <AppHeader
          key={'app-header'}
          uploadedIcons={state.uploadedIcons}
          setUploadedIcons={this.setUploadedIcons}
          showPublishChanges={showPublishChanges}
          showPublishWarningBanner={this.showPublishWarningBanner}
        />}
      {props.isMobileVersion &&
        <MobileAppHeader
          key={'mobile-app-header'}
          toggleMenu={this.toggleMobileMenu}
          isVersionPreview={props.isVersionPreview}
          hasTemplatesPermission={props.hasTemplatesPermission}
          pageInViewportNumber={util.getPageInViewportNumber()}
          props={props}
        />}

      {!props.isMobileVersion && <AppSubheader key={'app-subheader'}/>}

      {/*<PublishWarningBanner 
        showBanner={state.isPublishWarningBanner} 
        showPublishChanges={showPublishChanges} 
        showPublishChangesDSA={showPublishChangesDSA}
        onShow={this.showPublishWarningBanner} 
        onClose={this.closePublishWarningBanner} 
      />*/}

      {!props.isMobileVersion &&
        <AppAsideNav
          hasPdfPermission={props.hasPdfPermission}
          hasTemplatesPermission={props.hasTemplatesPermission}
          key={'app-aside-nav'}
          view={props.view}
        />}

      {!props.isMobileVersion && props.view !== "print" &&
      <AppAside key={'app-aside'}
        hasPdfPermission={props.hasPdfPermission}
        hasTemplatesPermission={props.hasTemplatesPermission}
        isVersionPreview={props.isVersionPreview}
        uploadedImages={state.uploadedImages}
        setUploadedImages={this.setUploadedImages}
      />}

      {state.isMobileMenu && <MobileAppMenu
        isLogged={props.isLogged}
        designId={props.designId}
        designName={props.designName}
        designSize={props.designSize}
        isCustomSize={props.isCustomSize}
        isSocialDesign={props.isSocialDesign}
        isLogo={props.isLogo}
        isDigitalMenuBoard={props.isDigitalMenuBoard}
        toggleMenu={this.toggleMobileMenu}
        websiteToken={props.websiteToken}
        props={props}
        parentId={props.parentId}
        lastSavedTag={props.lastSavedTag}
        showPublishChanges={showPublishChanges} 
        showPublishChangesDSA={showPublishChangesDSA}
        showPublishWarningBanner={this.showPublishWarningBanner} />}

      <AppCanvas isDesignLoading={props.isDesignLoading}
                 isVersionPreview={props.isVersionPreview}
                 isTakeout={props.isTakeout}
                 isFoldedMenu={props.isFoldedMenu}
                 isTableTent={props.isTableTent}
                 isSticker={props.isSticker}
                 isLabel={props.isLabel}
                 isSandwichBoard={props.isSandwichBoard}
                 isMobileVersion={props.isMobileVersion}
                 isDigitalMenuBoard={props.isDigitalMenuBoard}
                 hasVideo={props.hasVideo}
                 isViewAllPages={props.isViewAllPages}
                 hasViewOnlyPermission={state.hasViewOnlyPermission}
                 pages={util.getNumberOfPages()}/>

      {!props.isMobileVersion && <RightMenu key={'right-menu'}/>}

      {!props.isMobileVersion && props.hasVideo && <VideoPlaybackControls/>}

      {props.view === "print" &&
        <AppAsideRight key={'app-aside-right'}
                       view={props.view}
                       onClose={this.closeAppAsideRight}
                       designSize={props.designSize}
                       paperSize={width + 'x' + height}
                       pages={util.getNumberOfPages()}
                       designId={props.designId}
                       templateId={props.templateId}
                       designName={props.designName}
                       memberId={props.memberId}
                       isMobileVersion={props.isMobileVersion}
                       locationId={props.locationId}
                       setShowExitWarning={props.setShowExitWarning}
                       showMatchingDesignsModal={this.showMatchingDesignsModal}/>
      }

      {props.isMobileVersion &&
        <div className="mobile-bottom-menu">
          <MobileAppAside
            key={'mobile-app-aside'}
            view={props.view}
            props={props}
            hasTemplatesPermission={props.hasTemplatesPermission}
            uploadedImages={state.uploadedImages}
            setUploadedImages={this.setUploadedImages}
            uploadedIcons={state.uploadedIcons}
            setUploadedIcons={this.setUploadedIcons}
          />
          <MobileAppSubheader key={'mobile-app-subheader'}/>
        </div>}

      <Promos key={'promos'}/>

      {store.getState().printAdvisor.enabled && <PrintAdvisor/>}
      {props.isCollectionModal && <CollectionModal onClose={() => props.showCollections(false)}/>}

      <NewTemplateModal open={state.isTemplateModal} onModalClose={this.onTemplateModalClose}/>

      {props.isMenuContentModal && !props.isMobileVersion &&
        <MenuContentModal open={props.isMenuContentModal} onModalClose={this.onMenuContentModalClose}/>}

      <DataLibrary open={store.getState().isDataLibraryModal} onModalClose={() => this.onDataLibraryClose()} isMockData={props.isMockData}
                   isClover={props.isClover} isSquare={props.isSquare} isTreez={props.isTreez} isPopmenu={props.isPopmenu}/>

      <PosConnectModal open={store.getState().isPosConnectModal} onClose={() => store.dispatch(actions.setIsPosConnectModal(false))}
                       hasPdfPermission={props.hasPdfPermission} setActiveMember={props.setActiveMember}/>

      <ImportFromWebsite open={props.isImportWebsiteModal}/>

      <MMGTourModal open={store.getState().isMMGTourModal} onClose={() => store.dispatch(actions.setIsMMGTourModal(false))}/>

      <POSTourModal isSquare={store.getState().isSquare} isTreez={store.getState().isTreez} isPopmenu={store.getState().isPopmenu} open={store.getState().isPOSTourModal}
                    onClose={() => store.dispatch(actions.setIsPOSTourModal(false))}/>

      <AltTextModal
        open={store.getState().isAltTextModal}
        onClose={() => store.dispatch(actions.setIsAltTextModal(false))}
        isMobile={props.isMobileVersion}
        $element={props.$element}
        selectedUploadedImage={props.selectedUploadedImage}
        selectedUploadedIcon={props.selectedUploadedIcon}
        uploadedImages={state.uploadedImages}
        setUploadedImages={this.setUploadedImages}
        uploadedIcons={state.uploadedIcons}
        setUploadedIcons={this.setUploadedIcons}
      />

      {!props.isMobileVersion && <div id="version">
        {BUILD.branch} {BUILD.date}
      </div>}

      {/*state.isInUse && <InUseModal/>*/}
      {/*state.noLocationPermission && <NoLocationPermissionModal/>*/}

      {state.matchingDesignModalOpen && <MatchingDesignModal templateId={props.templateId} setShowExitWarning={props.setShowExitWarning} onModalClose={this.onMatchingDesignModalClose}/>}

      <span id="mhm-user-status" className="timber-user" style="display:none">{window.data.member.statusDescription}</span>
      <div className="modal-back" style="display:none"/>
      <div className="close-full-screen" onClick={this.exitPreview}>Exit Preview</div>
      <div id="qrcode" style="display: none"/>
    </div>
  }
}
